import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDisplayFilterSearchParam = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const displayFilter = useMemo(() => {
        return searchParams.get('displayFilter') !== null;
    }, [searchParams]);

    const toggleDisplayFilter = useCallback(() => {
        setSearchParams(
            current => {
                if (current.get('displayFilter') !== null) {
                    current.delete('displayFilter');
                } else {
                    current.set('displayFilter', '');
                }

                return current;
            },
            { replace: true }
        );
    }, [setSearchParams]);

    return { displayFilter, toggleDisplayFilter };
};
